export default __webpack_public_path__ + "static/media/CNo.53-0.64e7475d.jpg";